import "../index.js";
import type {NexusResult, OttoNexus} from "@otto-ec/global-resources/nexus";
import {apps} from "../index.js";
import type { AppType } from "../helper/appInfo.js";
export { AppType } from "../helper/appInfo.js";

export type NativeAppEvent = {
    /**
 *
 */
    name: string;
    /**
 *
 */
    timestamp: Date;
}

export type GlobalRaw = {
    /**
 *
 */
    retrieveNativeAppEvents(): NexusResult<Promise<NativeAppEvent[]>>;

    /**
 *
 */
    runningInApp(): NexusResult<boolean>;

    /**
 *
 */
    appType(): NexusResult<AppType | undefined>;

    /**
 *
 */
    appVersion(): NexusResult<Promise<string | undefined>>;
}

export type AppsGlobal = OttoNexus["apps"]["global"]

/**
 *
 */
export const global: AppsGlobal = apps.global;

/**
 *
 */
export const retrieveNativeAppEvents: AppsGlobal["retrieveNativeAppEvents"] = global.retrieveNativeAppEvents;

/**
 *
 */
export const runningInApp: AppsGlobal["runningInApp"] = global.runningInApp;

/**
 *
 */
export const appType: AppsGlobal["appType"] = global.appType;

/**
 *
 */
export const appVersion: AppsGlobal["appVersion"] = global.appVersion;

